module.exports = __webpack_public_path__ + "static/media/fbLogo.eceab7b4.png";